// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"71":"68bff6e5","96":"ba8946d8","278":"a0050036","372":"a47f5554","916":"1ca8f026"}[chunkId] + ".js";
};